import React from 'react';
import { observer } from 'mobx-react';
import { Button, Form, Icon, TextArea, Input, Select } from 'semantic-ui-react';
import { action, toJS } from 'mobx';
import Modal from '../../shared/Modal';
import ServiceFeeStore from './AMAServiceFeeStore';
import customFetch from '../../../utils/customFetch';
import orderBy from 'lodash/orderBy';
import { SelectSearch } from '../../shared/form/Input';
import { uniqBy } from 'lodash';

const statusOptions = [
  {
    text: 'Active',
    value: 0,
  },
  {
    text: 'Inactive',
    value: 1,
  },
];

@observer
class ModalCreateEditServiceFee extends React.Component {
  constructor(props) {
    ServiceFeeStore.fetchExcludedAMACodeFiles(ServiceFeeStore.modalParams.id);
    ServiceFeeStore.refetch({ isSelectionList: true, arrExcludedId: [] }, true);
    super(props);
    this.state = {
      Id: ServiceFeeStore.modalParams.id,
      AMACode:
        ServiceFeeStore.modalParams.record &&
        ServiceFeeStore.modalParams.record.AMACode
          ? ServiceFeeStore.modalParams.record.AMACode
          : '',
      ServiceType:
        ServiceFeeStore.modalParams.record &&
        ServiceFeeStore.modalParams.record.ServiceType
          ? ServiceFeeStore.modalParams.record.ServiceType
          : '',
      MBSCode:
        ServiceFeeStore.modalParams.record &&
        ServiceFeeStore.modalParams.record.MBSCode
          ? ServiceFeeStore.modalParams.record.MBSCode
          : '',
      Description:
        ServiceFeeStore.modalParams.record &&
        ServiceFeeStore.modalParams.record.Description
          ? ServiceFeeStore.modalParams.record.Description
          : '',
      TypeProcedures:
        ServiceFeeStore.modalParams.record &&
        ServiceFeeStore.modalParams.record.TypeProcedures
          ? ServiceFeeStore.modalParams.record.TypeProcedures
          : '',
      Fee:
        ServiceFeeStore.modalParams.record &&
        ServiceFeeStore.modalParams.record.Fee
          ? ServiceFeeStore.modalParams.record.Fee
          : '',
      PublishedYear:
        ServiceFeeStore.modalParams.record &&
        ServiceFeeStore.modalParams.record.PublishedYear
          ? ServiceFeeStore.modalParams.record.PublishedYear
          : '',
      Status: ServiceFeeStore.modalParams.record
        ? ServiceFeeStore.modalParams.record.Status
        : 0,
      Keyword:
        ServiceFeeStore.modalParams.record &&
        ServiceFeeStore.modalParams.record.Keyword
          ? ServiceFeeStore.modalParams.record.Keyword
          : '',
    };
  }

  renderStatusLabel = () => {
    return statusOptions.map(i => ({
      text: i.text,
      value: i.value,
    }));
  };

  handleResetDataModal = () => {
    ServiceFeeStore.setFieldsValue(
      { isSelectionList: false, arrExcludedId: [], searchExcludedText: '' },
      true,
    );
  };

  componentWillUnmount() {
    this.handleResetDataModal();
  }

  renderStatusLabelText = value => {
    return statusOptions.filter(i => i.value === value).map(i => i.text)[0];
  };

  @action onChangeExcludedAMA = (_, { value }) => {
    ServiceFeeStore.listExcludedAMA = value;
  };

  @action onDoctorSelectChange = (_, { value, options }) => {
    ServiceFeeStore.arrExcludedId = value;
    ServiceFeeStore.selectedExcluded = options.filter(
      o => !!value.find(v => v === o.value),
    );
    ServiceFeeStore.searchExcludedText = '';
  };

  handleEditServiceItem = () => async () => {
    if (!this.state.AMACode) {
      return;
    }

    if (!this.state.Fee) {
      return;
    }

    ServiceFeeStore.setFieldsValue({ loading: true });
    try {
      var request = { ...this.state };
      request.ListExcludedAMA = ServiceFeeStore.arrExcludedId;

      await customFetch('/MAGService/SaveAMAFeeCode', {
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify(request),
      }).then(respone => {
        if (respone.status === 'success') {
          this.props.onCancel();
        }
      });
      await ServiceFeeStore.fetchFiles({}, true);
    } finally {
      ServiceFeeStore.setFieldsValue({ loading: false });
    }
  };

  handleChangeDropdown = (_, { name, value }) => {
    this.setState({
      ...this.state,
      [name]: value,
    });
  };

  onChange = event => {
    console.log('event', event);
    console.log('target', event.target);
    const { name, value } = event.target;
    this.setState({
      ...this.state,
      [name]: value,
    });
  };

  onCancel = () => {
    this.props.onCancel();
  };

  handleChangeSearchDropdown = (_, { searchQuery }) => {
    return ServiceFeeStore.refetch({
      searchExcludedText: searchQuery,
      numberPageSearch: 30,
      loadingSearch: true,
      isSelectionList: true,
    });
  };

  renderExcludedAMA = () => {
    const amaSelectionList = uniqBy(
      [
        ...toJS(ServiceFeeStore.amaSelectionList),
        ...toJS(ServiceFeeStore.selectedExcluded),
      ],
      'key',
    );
    const options = orderBy(amaSelectionList || []).map(r => ({
      key: r.value,
      text: `${r.text}`,
      value: r.value,
      content: (
        <div>
          <div className="text-bold">{r.text}</div>
        </div>
      ),
    }));

    return (
      <SelectSearch
        label="Excluded Service Codes 2"
        multiple
        placeholder="Select AMA Fee Code"
        noResultsMessage="No AMA Fee Code found"
        disabled={ServiceFeeStore.loadingSearch}
        options={options}
        value={toJS(ServiceFeeStore.arrExcludedId)}
        onChange={this.onDoctorSelectChange}
        onSearchChange={this.handleChangeSearchDropdown}
        searchQuery={ServiceFeeStore.searchExcludedText}
      />
    );
  };

  render() {
    const { open } = ServiceFeeStore;
    return (
      <Modal
        visible={open}
        width={600}
        onCancel={this.props.onCancel}
        footer={
          <React.Fragment>
            <Button color="blue" onClick={this.handleEditServiceItem()}>
              <Icon name="save" /> Save
            </Button>
            <Button color="red" onClick={this.onCancel}>
              <Icon name="close" /> Close
            </Button>
          </React.Fragment>
        }
        title="AMA Fee Code"
      >
        <Form onChange={this.onChange}>
          <Form.Field
            control={Input}
            label="AMA Code"
            placeholder="AMA Code"
            value={this.state.AMACode}
            required
            error={
              this.state.AMACode === '' || !this.state.AMACode
                ? {
                    content: 'This field is required',
                  }
                : null
            }
            name="AMACode"
          />
          <Form.Field
            control={Input}
            label="MBS Code"
            placeholder="MBS Code"
            value={this.state.MBSCode}
            name="MBSCode"
          />
          <Form.Field
            control={Input}
            label="Service Type"
            placeholder="Service Type"
            value={this.state.ServiceType}
            name="ServiceType"
          />
          <Form.Field
            control={Input}
            label="Type of Procedures"
            placeholder="Type of Procedures"
            value={this.state.TypeProcedures}
            name="TypeProcedures"
          />
          {this.renderExcludedAMA()}
          <Form.Field
            control={TextArea}
            label="Item Description"
            placeholder="Item Description"
            value={this.state.Description}
            name="Description"
          />
          <Form.Field
            control={Input}
            label="Fee"
            placeholder="Fee"
            value={this.state.Fee}
            name="Fee"
            required
            error={
              this.state.Fee === '' || !this.state.Fee
                ? {
                    content: 'This field is required',
                  }
                : null
            }
          />
          <Form.Field
            control={Select}
            label="Status"
            placeholder="Status"
            name="Status"
            value={this.state.Status}
            options={this.renderStatusLabel()}
            onChange={this.handleChangeDropdown}
          />
          <Form.Field
            control={Input}
            label="Published Year"
            placeholder="Published Year"
            value={this.state.PublishedYear}
            name="PublishedYear"
          />
          <Form.Field
            control={Input}
            label="Keyword"
            placeholder="Keyword"
            value={this.state.Keyword}
            name="Keyword"
          />
        </Form>
      </Modal>
    );
  }
}

export default ModalCreateEditServiceFee;
